// extracted by mini-css-extract-plugin
export var cardItem = "index-module--cardItem--qdfoP";
export var cardSwiperWrapper = "index-module--cardSwiperWrapper--GPfKx";
export var cardSwiperWrapperMb = "index-module--cardSwiperWrapperMb--ccf8x";
export var desc = "index-module--desc--v761M";
export var enTitle = "index-module--enTitle--RPZoK";
export var firstLine = "index-module--firstLine--W15OV";
export var head = "index-module--head--7nl9i";
export var icon = "index-module--icon--IDq6j";
export var linkText = "index-module--linkText--WeRYk";
export var otherLine = "index-module--otherLine--YhFUQ";
export var titles = "index-module--titles--+GsSM";
export var zhTitle = "index-module--zhTitle--olJp1";